<h2 mat-dialog-title>{{ data?.user ? 'Edit User' : 'Add User' }}</h2>

<mat-dialog-content>
  <div class="form-container" [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>First Name</mat-label>
      <input matInput formControlName="firstName">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="lastName">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email</mat-label>
      <input matInput formControlName="emailAddress" type="email">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Roles</mat-label>
      <mat-select formControlName="roles" multiple>
        <mat-option *ngFor="let role of availableRoles"
                    [value]="role"
                    [disabled]="isExternalUser && !['DCOUser','ProviderUser'].includes(role.name)">
          {{ role.name }}
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="isExternalUser">
        External users may only be assigned: DCOUser, ProviderUser.
      </mat-hint>
    </mat-form-field>

    <!-- group-level error note -->
    <div class="error" *ngIf="form.errors?.['externalRoleViolation']">
      External users can only have the DCOUser and/or ProviderUser roles.
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Dental Care Organization</mat-label>
      <mat-select formControlName="dcoId">
        <mat-option *ngFor="let dco of availableDcos" [value]="dco.id">
          {{ dco.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox formControlName="isActive">Active</mat-checkbox>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Save</button>
</mat-dialog-actions>
